import { useEffect } from 'react';

import { Atom, useAtomValue, useSetAtom, type PrimitiveAtom } from 'jotai';

export const useSyncAtom = <T>(
    atom: PrimitiveAtom<T> | PrimitiveAtom<T | undefined>,
    data: T | null | undefined,
    syncNull = false,
) => {
    const setAtom = useSetAtom(atom);
    useEffect(() => {
        if (!syncNull && data) {
            setAtom(data);
        } else if (syncNull) {
            setAtom(data || undefined);
        }
    }, [data]);
};

export const useEnsureAtomValue = <T>(atom: Atom<T> | Atom<T | undefined>, errorMessage?: string) => {
    const data = useAtomValue(atom);
    if (!data) {
        throw new Error(errorMessage ?? 'Atom must have value set');
    }
    return data;
};
